import { render, staticRenderFns } from "./UnderDevelopement.vue?vue&type=template&id=3a14a41f&scoped=true&"
import script from "./UnderDevelopement.vue?vue&type=script&lang=js&"
export * from "./UnderDevelopement.vue?vue&type=script&lang=js&"
import style0 from "./UnderDevelopement.vue?vue&type=style&index=0&id=3a14a41f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a14a41f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
